import { useQuery } from "@tanstack/react-query";

import { ScmInstance } from "@/instance/axios";
import {
  PurchaseOrderCategoriesGet200Response,
  PurchaseOrderCategoriesGet200ResponseRowsInner,
} from "@sizlcorp/sizl-api-document/dist/models";

export type PurchaseOrderCategoryOption = {
  value: string;
  label: string;
};

export const usePurchaseOrderCategoriesAutoComplete = (
  focus = false,
  keyword = "",
  options?: {
    onSuccess: (data: PurchaseOrderCategoryOption[]) => void;
  },
) => {
  return useQuery(
    ["purchase-order-categories-get-autocomplete-keyword", keyword],
    () =>
      ScmInstance.purchaseOrderCategoriesFindPost({
        search: keyword,
        searchFields: ["name"],
      }).then((res) => res.data),
    {
      enabled: focus,
      select: (data: PurchaseOrderCategoriesGet200ResponseRowsInner[]): PurchaseOrderCategoryOption[] =>
        data.map((PurchaseOrderCategory) => {
          return {
            value: String(PurchaseOrderCategory.name),
            label: String(PurchaseOrderCategory.name),
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    },
  );
};

const getPurchaseOrderCategoryByName = (name: string | null) =>
  ScmInstance.purchaseOrderCategoriesGet({
    ...(name && { search: name }),
    searchFields: ["name"],
  }).then((res) => res.data);

export const usePurchaseOrderCategoriesCode = (
  enabled: boolean = false,
  name: string | null,
  options?: {
    onSuccess: (data?: PurchaseOrderCategoryOption[]) => void;
  },
) => {
  return useQuery(["purchase-order-categories-get-name", name], () => getPurchaseOrderCategoryByName(name), {
    enabled,
    select: (data: PurchaseOrderCategoriesGet200Response) =>
      data?.rows?.map((PurchaseOrderCategory) => {
        return {
          value: PurchaseOrderCategory.name as string,
          label: PurchaseOrderCategory.name as string,
        };
      }),
    onSuccess: options?.onSuccess,
  });
};
